module.exports = __webpack_public_path__ + "img/SER-i-1-III.23610ae9.png";